import React from 'react';
import Select from '../../components/Select/Select.jsx';

const withRequiredMark = (label, required) => (required && label ? `${label} *` : label);

/** Renders a dropdown for `oneOf`/`enum`-constrained schema properties. RJSF pre-computes
 * `options.enumOptions` as [{ value, label }] for us, matching our own Select's shape, so
 * no index-mapping dance is needed the way a native HTML <select> would require. */
const SelectWidget = ({ id, value, disabled, readonly, required, label, hideLabel, options, onChange }) => (
  <Select
    id={id}
    label={hideLabel ? undefined : withRequiredMark(label, required)}
    floatingLabel
    value={value}
    options={options?.enumOptions ?? []}
    disabled={disabled || readonly}
    required={required}
    fullWidth
    onChange={(newValue) => onChange(newValue)}
    menuPortal
  />
);

export default SelectWidget;
